import SharingMenu from './components/sharing-menu';
import InlineShare from './components/inline-share';

window.addEventListener('DOMContentLoaded', () => {
    // Initialize the sharing menu functionality
    document.querySelectorAll('.sharing-menu').forEach(el => {
        new SharingMenu(el);
    });

    // Initialize inline sharing functionality
    if (document.getElementById('roar-inline-share-template')) {
        document.querySelectorAll('[data-inline-share]').forEach(el => {
            new InlineShare(el);
        });
    }
});
